import GridModel from './gridmodel';
const formatDate = require('../utils/formatdate');

const LocationAddressViewModel = Backbone.Model.extend({
  idAttribute: 'locationID',
	initialize: function() {
		if (!_.isUndefined(this.get('address'))) {
			this.set({ address: new Backbone.Model(this.get('address')) });
		} else {
      this.set({ address: new Bacbone.Model() });
    }
	}
});

const LocationModel = GridModel.extend({
  idAttribute: 'locationID',
  initialize() {
    GridModel.prototype.initialize.call(this);
    this.set({
      createDate: formatDate(this.get('createDate')),
      modifyDate: formatDate(this.get('modifyDate')),
      locationAddressViews: new Backbone.Collection(this.get('locationAddressViews'), {model: LocationAddressViewModel})
    })
  }
})

export default LocationModel;
